module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Schedule","principalsSumError":"Sum of contract principals is greater than contract amount"},"et":{"title":"Schedule","principalsSumError":"Sum of contract principals is greater than contract amount"},"ru":{"title":"Schedule","principalsSumError":"Sum of contract principals is greater than contract amount"}}')
  delete Component.options._Ctor
}
